export enum KeycloakTypes {
  office = 'office',
  mass = 'mass',
}
